import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { ArrowRightOutlined } from '@ant-design/icons';
import { primaryFont, primaryHeadingColor, secondaryFont, wLight, wMBold, maxTablet, greyColorSecondary, wMedium } from '../../../Utils/utilsStyle';
import CloseIconFilled from '../../company/svgIcons/CloseIconFilled';
import { useDispatch } from 'react-redux';
import { actions } from '../../../Slice/PersonProfileSlice';
import { Tooltip } from 'antd';

const StyleWrapper = styled.div`
  position: relative;
  .close-icon-div {
    position: absolute;
    top: 0px;
    right: -30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
  }
  .image-div {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 105px;
    margin: 0 auto;
  }
  .person-details {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 5px;
    .person-name {
      color: ${primaryHeadingColor};
      text-align: center;
      font-family: ${secondaryFont};
      font-size: 16px;
      font-weight: ${wMBold};
      line-height: 18.095px;
      letter-spacing: -0.377px;
      max-width: 160px;
    }
    .person-designation {
      color: ${greyColorSecondary};
      text-align: center;
      font-family: ${primaryFont};
      font-size: 12px;
      font-weight: ${wLight};
      line-height: 15.079px;
      letter-spacing: -0.302px;
      max-width: 160px;
    }
    .person-company {
      color: ${greyColorSecondary};
      text-align: center;
      font-family: ${primaryFont};
      font-size: 12px;
      font-weight: ${wMedium};
      line-height: 14px;
      letter-spacing: -0.154px;
      max-width: 160px;
    }
  }
`;
const ImageWrapper = styled.div<{ border: string }>`
  background: conic-gradient(from -70deg, ${(props) => props.border});
  width: 105px;
  height: 105px;
  min-width: 105px;
  max-width: 105px;
  flex-shrink: 0;
  border-radius: 50%;
  padding: 3px;
`;
const Image = styled.div<{ image: string }>`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid #fff;
  background-image: url(${(props) => props.image});
  background-position:center;
  background-size:cover;
  background-color: #fff;
`;
const PersonalityWrapper = styled.div<{ color: string }>`
  width: fit-content;
  background: linear-gradient(to right, ${(props) => props.color}, ${(props) => props.color});
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  column-gap: 7px;
  color: white;
  padding: 3px 10px;
  border-radius: 15px;
  position: absolute;
  bottom: -5px;
  h4 {
    margin: 0px;
    color: #FFF;
    text-align: center;
    font-family: ${secondaryFont};
    font-size: 10px;
    font-style: normal;
    font-weight: ${wMBold};
    line-height: 12px;
    letter-spacing: -0.264px;
  }
`;
type Props = {
  closeIconVisible?: boolean;
  personImage: string,
  personName: string,
  personDesignation: string,
  persona: string,
  typeName: string,
  personId: number,
  companyName?: string,
  rowId: number,

};

const defaultProps = {
  closeIconVisible: false,
  personImage: '',
  personName: '',
  personDesignation: '',
  persona: '',
  typeName: '',
  personId: 0,
  companyName: '',
  rowId: 0,
}
const PersonWidgetSalesAlignment = function PersonWidgetSalesAlignment(props: Props) {
  const { closeIconVisible, personImage, personDesignation, personName, persona, typeName, personId, companyName, rowId } = props;
  const dispatch = useDispatch();

  const handleClose = (personId: number, rowId: number) => {
    dispatch(actions.removeMultiSalesPerson({ personId, rowId }));
  }
  return (
    <StyleWrapper>
      <div className='image-div'>
        <ImageWrapper border={persona} className='image-wrapper'>
          <Image
            image={personImage}
          />
        </ImageWrapper>
        {
          closeIconVisible && (
            <div
              className='close-icon-div'
              onClick={() => handleClose(personId, rowId)}
              role='button'
              tabIndex={0}
            >
              <CloseIconFilled />
            </div>
          )
        }
        <PersonalityWrapper color={persona}>
          <h4>{typeName}</h4>
          <ArrowRightOutlined />
        </PersonalityWrapper>
      </div>
      <div className='person-details'>
        <div className='person-name text-truncate-one-line'>
          {personName}
        </div>
        <Tooltip
          trigger="hover"
          placement="bottom"
          getPopupContainer={(e: HTMLElement) => e}
          className="triggers-bullet-tooltip person-designation-tip"
          color="#fff"
          title={personDesignation}
          arrow={false}
          autoAdjustOverflow={false}
        >
          <div className='person-designation text-truncate-one-line'>
            {personDesignation}
          </div>
        </Tooltip>
        <div className='person-company text-truncate-one-line'>
          {companyName}
        </div>
      </div>
    </StyleWrapper>
  );
};
PersonWidgetSalesAlignment.defaultProps = defaultProps;
export default PersonWidgetSalesAlignment;
